import React, { useContext } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { Checkbox, Form } from 'semantic-ui-react'
import { StyledGroup } from '../../../../Co2Climate/AnswerCO2Climate/Steps/GrassSilageStep/style'
import { StyledDivider } from '../ElevenStep/style'
import { SummaryOptionsContext } from '.'

const AllgemeinStep: React.FC = () => {
  const { control, setValue, clearErrors } = useFormContext()
  const { milkingTechnologies } = useContext(SummaryOptionsContext)
  const watchMilkingTechnology = useWatch({ control, name: 'additionalQuestions.milkingTechnology' })

  return (
    <div style={{ marginTop: '2em' }}>
      <StyledGroup widths={'equal'}>
        <Controller
          control={control}
          name='additionalQuestions.milkingTechnology'
          rules={{ required: true }}
          render={({ fieldState: { error } }) => (
            <Form.Field error={Boolean(error)}>
              <label className='title' style={{ width: 'fit-content' }}>
                <div>{'Welche Melktechnik kommt in Ihrem Betrieb zum Einsatz?'}</div>
                <StyledDivider />
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {milkingTechnologies.map(option => (
                  <Checkbox
                    radio
                    key={option.key}
                    label={option.label}
                    checked={watchMilkingTechnology === option.key}
                    onClick={() => {
                      setValue('additionalQuestions.milkingTechnology', option.key)
                      clearErrors('additionalQuestions.milkingTechnology')
                    }}
                  />
                ))}
              </div>
            </Form.Field>
          )}
        />
      </StyledGroup>
    </div>
  )
}

export default AllgemeinStep
